import { render, staticRenderFns } from "./indicadores_administradores.vue?vue&type=template&id=9ceb5b58&"
import script from "./indicadores_administradores.vue?vue&type=script&lang=ts&"
export * from "./indicadores_administradores.vue?vue&type=script&lang=ts&"
import style0 from "./indicadores_administradores.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports